import React, {useState} from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import Button from '@mui/material/Button';
import jigsaw_puzzle_unsolved from '../static/images/questionImages/jigsaw_puzzle_unsolved.gif';
import DeveloperInfo from '../components/common/DeveloperInfo';
import puzzle_solved from '../static/images/questionImages/jigsaw_puzzle_solved.png';
import Alert from '@mui/material/Alert';

function JigsawPuzzleTask() {
  const [showImage, setShowImage] = useState(false);
  const [isSolved, setIsSolved] = useState(false);
  return <div>
    <h2>Jigsaw Puzzle Basic</h2>
    <FormControl required={true} fullWidth={true}>
      <FormLabel id="image-url-label">Image URL</FormLabel>
      <TextField id="image-url" label="https://image.url/test.jpg" variant="outlined"/>
    </FormControl>

    <FormControl required={true} fullWidth={true}>
      <FormLabel id="demo-radio-buttons-group-label">Grid</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue="female"
        name="radio-buttons-group"
      >
        <FormControlLabel value="2" control={<Radio/>} label="2 X 2"/>
        <FormControlLabel value="3" control={<Radio/>} label="3 X 3"/>
        <FormControlLabel value="4" control={<Radio/>} label="4 X 4"/>
      </RadioGroup>
    </FormControl>
    <FormControl>
      <Button variant="contained" onClick={() => setShowImage(true)}>Load Puzzle</Button>
    </FormControl>
    <div>
      {(showImage && !isSolved) && <img src={jigsaw_puzzle_unsolved} alt="puzzle" width={'300px'}
                                        height={'300px'}/>}
    </div>
    <div>
      {isSolved && <div><img
        alt={'Puzzle solved image'}
        width={'300px'}
        height={'300px'}
        src={puzzle_solved}/>
        <Alert> You've solved the puzzle!</Alert>
      </div>}

    </div>
    <DeveloperInfo>
      <Button onClick={() => setIsSolved(true)}>Show success screen </Button>

    </DeveloperInfo>
  </div>
}

export default JigsawPuzzleTask;